<!-- eslint-disable vue/no-v-html -->
<template>
  <modal
    class="question-modal"
    :open="showModal"
    :show-close="true"
    @closed="closeModal"
  >
    <div class="question-modal__content">
      <template
        v-if="title"
        slot="heading"
      >
        <p
          class="title"
          v-html="title"
        />
      </template>

      <tab>
        <template
          slot="tab-controls"
          slot-scope="{
            controlDynamicClasses,
            isAriaSelected,
            selectTab,
            selectTabWithKey,
          }"
        >
          <ul
            v-if="slides && slides.length > 1"
            class="tab-control-list"
            role="tablist"
            :style="tabControlListStyle"
          >
            <li
              v-for="(slide, index) in slides"
              :key="`tab-control-item-${index}`"
              class="tab-control-item"
              @click="scrollToTop"
            >
              <button
                :id="`tab-${index}`"
                :aria-controls="`panel-${index}`"
                :aria-selected="isAriaSelected(`${index}`)"
                class="tab-control"
                :class="controlDynamicClasses(`${index}`)"
                role="tab"
                @click="selectTab(`${index}`)"
                @keyup="selectTabWithKey"
                v-text="slide.title"
              />
            </li>
          </ul>
        </template>

        <template
          slot="tab-panels"
          slot-scope="{ panelDynamicClasses }"
        >
          <div
            v-for="(slide, index) in slides"
            :id="`panel-${index}`"
            :key="`tab-panel-${index}`"
            :aria-labelledby="`tab-${index}`"
            class="tab-panel"
            :class="panelDynamicClasses(`${index}`)"
            role="tabpanel"
          >
            <picture v-if="isValidImage(slide.image)">
              <source
                v-for="source in slide.image.srcset"
                :key="source.media"
                :height="source.height"
                :media="source.media"
                :srcset="source.src"
                :width="source.width"
              >
              <img
                :alt="slide.image.alt"
                class="intrinsic-size"
                :height="slide.image.default.height"
                loading="lazy"
                :src="slide.image.default.src"
                :width="slide.image.default.width"
              >
            </picture>

            <div
              v-if="slide.title || slide.text"
              v-html="slideCopy(slide.title, slide.text)"
            />
          </div>
        </template>
      </tab>

      <button
        v-if="confirmLabel"
        v-tag:useractionevent.dom
        class="btn btn--secondary btn--ghost"
        :data-tag-action="`${currentStepNumber}::back to quiz`"
        data-tag-category="skincare finder"
        data-tag-ecommerce="undefined"
        :data-tag-label="confirmLabel"
        data-tag-wrapper
        dom="true"
        event="useractionevent"
        @click="closeModal"
        v-text="confirmLabel"
      />

      <template slot="close">
        <button
          class="close-button"
          @click="closeModal"
        >
          <svg
            class="close-button__icon"
            role="img"
          >
            <title
              v-if="tooltipCommon && tooltipCommon.closeLabel"
              v-text="tooltipCommon.closeLabel"
            />
            <use xlink:href="#close-x" />
          </svg>
        </button>
      </template>
    </div>
  </modal>
</template>

<script>
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import { mapGetters } from 'vuex';
  import { modalEventBus, storeNamespace } from '../constants';
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import Modal from '@Feature/Modal/code/Scripts/components/Modal/Modal.vue';
  import Tab from '@Feature/Tab/code/Scripts/components/Tab/Tab.vue';

  export default {
    name: 'QuestionModal',

    directives: { tag },

    components: { Modal, Tab },

    props: {
      confirmLabel: {
        default: null,
        type: String,
      },
      slides: {
        default: null,
        type: Array,
      },
      tabControlGrid: {
        default: () => ({
          desktop: 4,
          mobile: 2,
        }),
        type: Object,
      },
      title: {
        default: null,
        type: String,
      },
    },

    data: () => ({
      showModal: false,
    }),

    computed: {
      ...mapGetters(storeNamespace, [
        'currentStepNumber',
        'tooltipCommon',
      ]),

      tabControlListStyle() {
        let style = '';

        style += `--tab-control-grid: ${this.tabControlGrid.mobile};`;
        style += `--tab-control-grid-lg: ${this.tabControlGrid.desktop};`;

        return style;
      },
    },

    mounted() {
      eventBus.$on(modalEventBus, status => {
        this.showModal = status;
      });
    },

    methods: {
      closeModal() {
        this.showModal = false;
      },

      isValidImage(imageObject) {
        return imageObject && imageObject.default && imageObject.default.src;
      },

      scrollToTop() {
        document.querySelector('.modal').scrollTo({
          behavior: 'smooth',
          top: 0,
        });
      },

      slideCopy(title, text) {
        let copy = ''

        if (title) {
          copy += `<p><strong>${title}</strong></p>`
        }

        if (text) {
          copy += text;
        }

        return copy;
      },
    },
  };
</script>

